export default {
  title: 'Access denied',
  message: 'You must be signed in with the APP_ADMIN realm role to use this application.',
  backToLogin: 'Sign in with another account',
}
